import { all } from 'redux-saga/effects';

import { initSagaTakeEvery } from './initSaga';
import { comicSagaWatcher } from './comicSaga';

export default function* rootSaga() {
  yield all([comicSagaWatcher(), initSagaTakeEvery()]);
}
